module.exports = __webpack_public_path__ + "static/media/berries.74dc5a7b.webp";